import { appConstants } from "JS/Helpers/Constants";
import { BaseService } from "../BaseService";
import { KeysResponse } from "JS/Models";

class KeysService extends BaseService {
    getKeys = () =>
        this.ngCall<KeysResponse>("get", appConstants?.ngEndpoints?.keys);
}

export default KeysService;
